import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  ApiAuditDto,
  ApiAuditVm,
  ComparisonOperator,
} from 'src/app/core/api/models';
import { SuperAdminsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';
import { ApiDocuments } from '../../../core/api/models/api-documents';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ApiAuditsDetailsComponent } from './api-audits-details/api-audits-details.component';

@Component({
    selector: 'app-api-audits',
    templateUrl: './api-audits.component.html',
    imports: [BaseIndexModule, ApiAuditsDetailsComponent, TextPopoverDirective]
})
export class ApiAuditsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.apiAudits;

  protected currentService = inject(SuperAdminsService);
  paginationApiMethodName =
    this.currentService.superAdminsGetApiAuditsWithPagination.name;

  modelWithPagination$: Observable<ApiAuditVm>;
  items$: Observable<Array<ApiAuditDto>>;

  //details
  showDetails: boolean = false;
  detailModel: ApiDocuments;
  requestBody: string;
  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showRefreshBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.setPageService(this.currentService, 'privateNumbersCreateGet');
      this.pageConfig.tableConfig.pageSizes = [30, 40, 50, 60, 80, 100];
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Details_key) this.onDetail({}, false);
    }
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: `${this.tableVocabs}logCode`,
        name: 'Document.LogCode',
        hasSearch: true,
        type: 'enumValue',
        enumName: 'ApiServiceLogCode',
      },
      {
        title: `${this.tableVocabs}logText`,
        name: 'Document.LogText',
        hasSearch: true,
        noSorting: true,
        type: 'auditText',
      },
      {
        title: `${this.tableVocabs}requestPath`,
        name: 'Document.RequestPath',
        hasSearch: true,
        noSorting: true,
        type: 'auditText',
      },
      {
        title: `${this.tableVocabs}token`,
        name: 'Document.Token',
        hasSearch: true,
        noSorting: true,
        dir: 'ltr',
        customOperators: [
          ComparisonOperator.EqualTo,
          ComparisonOperator.StartsWith,
          ComparisonOperator.Contains,
        ],
      },
      {
        title: `${this.tableVocabs}tokenId`,
        name: 'Document.TokenId',
        hasSearch: true,
        dir: 'ltr',
        noSorting: true,
        customOperators: [
          ComparisonOperator.EqualTo,
          ComparisonOperator.StartsWith,
          ComparisonOperator.Contains,
        ],
      },
      {
        title: `${this.tableVocabs}tokenIp`,
        name: 'Document.TokenIp',
        hasSearch: true,
        dir: 'ltr',
        noSorting: true,
        customOperators: [
          ComparisonOperator.EqualTo,
          ComparisonOperator.StartsWith,
          ComparisonOperator.Contains,
        ],
      },
      {
        title: `${this.tableVocabs}status`,
        name: 'Document.Status',
        hasSearch: true,
        noSorting: true,
      },
      {
        title: `${this.tableVocabs}startDate`,
        name: 'Document.StartDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: `${this.tableVocabs}endDate`,
        name: 'Document.EndDate',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  setDefaultTableSort() {
    try {
      this.sortObject.push({ columnName: 'Document.StartDate', sort: 1 });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onDetail(model: ApiDocuments, setFiltersAndUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          JSON.stringify(model)
      );
    }
    this.showDetails = true;
    this.detailModel = model;
    this.requestBody = JSON.stringify(this.detailModel?.requestBody);
  }

  onCloseDetail(event) {
    this.showDetails = false;
  }
}
